// @ts-expect-error @headlessui/react incompatibility with node16 resolution
import {Disclosure} from '@headlessui/react';
import {useMemo} from 'react';
import {IconMinus, IconPlus} from '~/components';
import {DATA_TEST_IDS} from '~/lib/const';

export function ProductFeatures({
  children,
  content,
}: {
  children?: React.ReactNode;
  content: string;
}) {
  const items = useMemo(() => {
    try {
      return JSON.parse(content) as string[];
    } catch {
      console.error('Invalid JSON for ProductFeatures');

      return undefined;
    }
  }, [content]);

  if (!items) {
    return null;
  }

  return (
    <div
      data-testid={DATA_TEST_IDS.PRODUCT_FEATURES}
      className="border-t border-t-gray-300 py-5 lg:py-6"
    >
      <Disclosure as="div" className="grid w-full md:hidden">
        {({open}) => (
          <>
            <Disclosure.Button className="text-left">
              <div className="flex justify-between">
                <Title />
                {open ? (
                  <IconMinus
                    data-testid={DATA_TEST_IDS.ICON('minus')}
                    className="mr-3"
                  />
                ) : (
                  <IconPlus
                    data-testid={DATA_TEST_IDS.ICON('plus')}
                    className="mr-3"
                  />
                )}
              </div>
            </Disclosure.Button>

            <Disclosure.Panel>
              <Content items={items} />
            </Disclosure.Panel>
          </>
        )}
      </Disclosure>

      <div className="hidden md:block">
        <Title />
        {children}
        <Content items={items} />
      </div>
    </div>
  );
}

function Title() {
  return (
    <div className="text-22/22 lg:text-28/28 font-header font-bold">
      PRODUCT FEATURES
    </div>
  );
}

function Content({items}: {items: string[]}) {
  return (
    <ul className="text-18/26 mt-6">
      {items.map((item: string) => (
        <li
          data-testid={DATA_TEST_IDS.PRODUCT_FEATURES_CONTENT}
          key={item}
          className="before:w-1 before:h-1 before:bg-black before:flex before:rounded-full before:mx-3 flex items-center mt-[5px]"
        >
          {item}
        </li>
      ))}
    </ul>
  );
}
